module.exports = __webpack_public_path__ + "img/device.e7e6fef6.svg";